import easydropdown from "easydropdown-a11y";
import "@styles/components/dropdown.css";
import { on } from "delegated-events";
import ajax from "@common/ajax";
import { scrollToIfNeeded } from "@common/scroll-to";
import { generateQueryString } from "@common/util";
import { CountUp } from "countup.js";

const form = document.querySelector(".filter-form");

const setupDropdown = (el) => {
  if (el.tagName !== "SELECT") {
    return;
  }

  const opts = {
    behavior: {
      openOnFocus: true,
      maxVisibleItems: 10,
      liveUpdates: true,
      useNativeUiOnMobile: false,
    },
  };

  easydropdown(el, opts);
};

const handleFilterChange = (e) => {
  e && e.preventDefault();

  const params = new FormData(form);
  const queryString = generateQueryString(params);
  const url = queryString.size ? `${form.action}?${queryString}` : form.action;

  window.history.replaceState({}, "", url);

  updateResults();
};

const handleFilterClear = () => {
  form.reset();
  form.querySelectorAll("select").forEach((x) => (x.value = ""));

  window.history.replaceState({}, "", form.action);

  updateResults();

  document.body.classList.remove("is-searching");
};

const updateResults = async () => {
  const pageContent = document.querySelector("[data-page-content]");

  pageContent.classList.add("is-loading");

  const res = await ajax.get(window.location.href).json();

  pageContent.innerHTML = res.page;
  pageContent.classList.remove("is-loading");

  if (res.isFiltered) {
    form.classList.add("is-filtered");
    scrollToIfNeeded(pageContent, 24);
  } else {
    form.classList.remove("is-filtered");
  }

  handleCounter();
};

const handleCounter = () => {
  const pageContent = document.querySelector("[data-page-content]");
  const counters = pageContent.querySelectorAll("[data-counter]");

  counters.forEach((el) => {
    const end = parseFloat(el.dataset.counter.replace(/,/g, ""));
    const counter = new CountUp(el, end, {
      useGrouping: true,
      prefix: "$",
    });

    counter.start();
  });
};

const init = () => {
  if (form) {
    form.querySelectorAll("select:not([multiple])").forEach((el) => setupDropdown(el));

    on("change", ".filter-form select", handleFilterChange);
    on("submit", ".filter-form", handleFilterChange);
    on("click", ".filter-form-clear", handleFilterClear);

    handleCounter();
  }
};

init();
